import { useTranslation } from 'react-i18next';
import { LiliTextArea } from '@lili/lili-frontend-common';
import { CustomRadioButton } from '@Components/inputs/RadioButton/CustomRadioButton';
import { FieldError } from '@Components/inputs/FieldError';
import { ControllerWrapper } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';

export enum OrganizationRoleOptions {
  EXECUTIVE_DIRECTOR = 'EXECUTIVE_DIRECTOR',
  PRESIDENT = 'PRESIDENT',
  VICE_PRESIDENT = 'VICE_PRESIDENT',
  SECRETARY = 'SECRETARY',
  CFO_TREASURER = 'CFO_TREASURER',
  OTHER = 'OTHER',
}

interface OrganizationRoleFormProps {
  reactiveRole: string;
}

export const OrganizationRoleForm = ({ reactiveRole }: OrganizationRoleFormProps) => {
  const { t } = useTranslation('eddQuestions');

  const isOtherSelected = reactiveRole === OrganizationRoleOptions.OTHER;

  return (
    <div className='flex flex-col gap-[16px]'>
      <ControllerWrapper name={EddEmbeddedFields.EDD_ORGANIZATION_ROLE}>
        {({ onChange, value, error }) => (
          <>
            <CustomRadioButton
              label={t('organic.organizationRole.executiveDirector')}
              value={OrganizationRoleOptions.EXECUTIVE_DIRECTOR}
              onChange={onChange}
              checked={value === OrganizationRoleOptions.EXECUTIVE_DIRECTOR}
              name={EddEmbeddedFields.EDD_ORGANIZATION_ROLE}
            />
            <CustomRadioButton
              label={t('organic.organizationRole.president')}
              value={OrganizationRoleOptions.PRESIDENT}
              onChange={onChange}
              checked={value === OrganizationRoleOptions.PRESIDENT}
              name={EddEmbeddedFields.EDD_ORGANIZATION_ROLE}
            />
            <CustomRadioButton
              label={t('organic.organizationRole.vicePresident')}
              value={OrganizationRoleOptions.VICE_PRESIDENT}
              onChange={onChange}
              checked={value === OrganizationRoleOptions.VICE_PRESIDENT}
              name={EddEmbeddedFields.EDD_ORGANIZATION_ROLE}
            />
            <CustomRadioButton
              label={t('organic.organizationRole.secretary')}
              value={OrganizationRoleOptions.SECRETARY}
              onChange={onChange}
              checked={value === OrganizationRoleOptions.SECRETARY}
              name={EddEmbeddedFields.EDD_ORGANIZATION_ROLE}
            />
            <CustomRadioButton
              label={t('organic.organizationRole.cfoTreasurer')}
              value={OrganizationRoleOptions.CFO_TREASURER}
              onChange={onChange}
              checked={value === OrganizationRoleOptions.CFO_TREASURER}
              name={EddEmbeddedFields.EDD_ORGANIZATION_ROLE}
            />
            <div className='flex flex-col gap-[8px]'>
              <CustomRadioButton
                label={t('organic.organizationRole.other')}
                value={OrganizationRoleOptions.OTHER}
                onChange={onChange}
                checked={value === OrganizationRoleOptions.OTHER}
                name={EddEmbeddedFields.EDD_ORGANIZATION_ROLE}
              />
              {isOtherSelected && (
                <ControllerWrapper name={EddEmbeddedFields.EDD_ORGANIZATION_ROLE_OTHER_FREE_TEXT}>
                  {({ onChange: onOtherChange, value: otherValue, error: otherError, onBlur }) => (
                    <LiliTextArea
                      value={otherValue}
                      onValueChange={onOtherChange}
                      errorMsg={otherError?.message || ''}
                      externalErrorMessage={otherError?.message || ''}
                      maxLength={100}
                      minHeight='min-h-[88px]'
                      placeholder={t('organic.organizationRole.otherPlaceholder', 'Please specify')}
                      onBlur={onBlur}
                    />
                  )}
                </ControllerWrapper>
              )}
            </div>
            <FieldError error={error} testId={`${EddEmbeddedFields.EDD_ORGANIZATION_ROLE}-error`} />
          </>
        )}
      </ControllerWrapper>
    </div>
  );
};
